import { site } from "@/config/site";
import { leadSchema, type LeadInput } from "./schema";

export type LeadSubmitResult =
  | { status: "success" }
  | { status: "mailto" }
  | { status: "error"; message: string };

const FIELD_LABELS: Record<string, string> = {
  name: "Jméno a příjmení",
  company: "Firma",
  companyId: "IČO",
  email: "E-mail",
  phone: "Telefon",
  volume: "Kolik reklamací měsíčně řešíte",
  assortment: "Sortiment / obchodní model",
  wantTerms: "Chci také obchodní podmínky",
};

function buildMailto(values: LeadInput): string {
  const lines: string[] = [];
  for (const [key, label] of Object.entries(FIELD_LABELS)) {
    const raw = values[key as keyof LeadInput];
    if (typeof raw === "boolean") {
      if (raw) lines.push(`${label}: ano`);
      continue;
    }
    if (raw && raw.length > 0) {
      lines.push(`${label}: ${raw}`);
    }
  }

  const subject = `Poptávka reklamačního řádu – ${values.company || values.name || ""}`.trim();
  const body = ["Dobrý den,", "", "mám zájem o reklamační řád na míru.", "", ...lines, "", "Děkuji."].join(
    "\r\n",
  );

  return `mailto:${site.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

/**
 * Odeslání poptávky.
 * - Pokud je nastaven `NEXT_PUBLIC_LEAD_ENDPOINT`, odešle JSON a úspěch vrátí až po `res.ok`.
 * - Jinak otevře `mailto:` s předplněným obsahem (skutečná akce, žádný falešný success).
 */
export async function submitLead(input: LeadInput): Promise<LeadSubmitResult> {
  const parsed = leadSchema.safeParse(input);
  if (!parsed.success) {
    return {
      status: "error",
      message: "Formulář obsahuje neplatné údaje. Zkontrolujte prosím zvýrazněná pole.",
    };
  }

  const values = parsed.data;

  if (!site.leadEndpoint) {
    if (typeof window !== "undefined") {
      window.location.href = buildMailto(values);
    }
    return { status: "mailto" };
  }

  try {
    const response = await fetch(site.leadEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(values),
    });

    if (!response.ok) {
      return {
        status: "error",
        message:
          "Poptávku se nepodařilo odeslat. Zkuste to prosím znovu, nebo nám napište přímo e-mailem.",
      };
    }

    return { status: "success" };
  } catch {
    return {
      status: "error",
      message:
        "Spojení se serverem selhalo. Zkontrolujte připojení a zkuste to znovu, případně nám napište e-mailem.",
    };
  }
}
